module.exports = __webpack_public_path__ + "static/traditional-3f89341f5d229a076dbcee93baaeb978.png";